import { useEffect, useState } from "react";
import { MessageView } from "./Message";
import type { Conversation } from "../ReportScreen";
import { ReactComponent as SearchIcon } from "../../../assets/icons/search.svg";
import { twMerge } from "tailwind-merge";

const shouldHighlight = (msg: Conversation, activeTab: string, report: any[]) => {
  const pair = report.find((r) => r.Account_Specialist === msg.message  || r.Sales_Rep === msg.message);
  if (!pair) return false;
  const mergedMetrics = {...pair?.report?.constant_metrics, ...pair?.report?.variable_metrics};
  const score = mergedMetrics[activeTab];
  if (score?.sections) {
    return score.sections.metricsScore;
  }
  return false;
}

export function TranscriptView({
  title = "Transcript",
  conversations,
  currentIndex,
  activeTab,
  report,
  className,
  titleClassName,
}: {
  title?: string;
  conversations: Conversation[];
  currentIndex?: number;
  activeTab: string;
  report: any[];
  className?: string;
  titleClassName?: string;
}) {
  const [search, setSearch] = useState("");
  useEffect(() => {
    if (currentIndex === undefined) return;
    const message = conversations[currentIndex];
    if (message) {
      // scroll to message
      const el = document.getElementById(message.id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  }, [conversations, currentIndex]);

  return (
    <div className={twMerge("bg-white shadow-[0px_4px_24px_0px_rgba(203,90,90,0.05)] py-6 px-4 rounded-[14px]", className)}>
      <div className={twMerge("font-bold text-xl text-text-primary mb-2 px-2", titleClassName)}>{title}</div>
      <div className="flex items-center gap-2 mb-2 px-2 search-bar">
        <div className="relative w-full">
          {/** search bar */}
          <input 
          type="text" 
          placeholder="Search" 
          className="w-full p-2 rounded-md border border-gray-300 pl-8 outline-none" 
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          />
          <SearchIcon className="w-4 h-4 absolute left-2 top-1/2 -translate-y-1/2 [&_path]:stroke-[#A5A5A5]" />
        </div>
      </div>
      <div className="max-h-[calc(100vh-375px)] overflow-auto flex flex-col gap-5">
        {(conversations?.filter((msg) => !!(msg.message || msg.content)) ?? []).map((msg) => {
          const originalIndex = conversations?.findIndex((c) => c.id === msg.id) ?? -1;
          return (
            <MessageView
              key={msg.id}
              message={msg}
              isMe={msg.isUserMessage}
              isCurrent={originalIndex === currentIndex}
              highlight={false}
              search={search}
            />
          );
        })}
      </div>
    </div>
  );
}
